import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

function formatErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Hemanth.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink text-txt grid place-items-center pad-x relative overflow-hidden">
      <div className="grain" aria-hidden />
      <div
        aria-hidden
        className="pointer-events-none absolute -top-40 -right-40 w-[50vw] h-[50vw] rounded-full blur-[120px] opacity-40"
        style={{ background: "radial-gradient(circle, rgba(191,168,255,0.35), transparent 70%)" }}
      />
      <form onSubmit={submit} className="relative w-full max-w-sm bg-surface border border-hairline rounded-2xl p-8" data-testid="login-form">
        <p className="font-mono text-xs uppercase tracking-widest text-lav mb-2">owner access</p>
        <h1 className="font-display font-bold text-2xl mb-1">hemanth.kumar_s</h1>
        <p className="font-body text-sm text-mute mb-8">Sign in to edit the site.</p>

        <label className="block font-mono text-xs text-mute mb-2">email</label>
        <input
          type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          data-testid="login-email"
          className="w-full mb-5 bg-ink border border-hairline rounded-lg px-3 py-2.5 font-mono text-sm focus:border-lav outline-none"
          placeholder="admin@hemanth.studio"
        />
        <label className="block font-mono text-xs text-mute mb-2">password</label>
        <input
          type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
          data-testid="login-password"
          className="w-full mb-7 bg-ink border border-hairline rounded-lg px-3 py-2.5 font-mono text-sm focus:border-lav outline-none"
          placeholder="••••••••"
        />
        <button
          type="submit" disabled={loading}
          data-testid="login-submit"
          className="w-full bg-lav text-ink font-mono text-xs uppercase tracking-wide rounded-full py-3 hover:opacity-90 transition-opacity disabled:opacity-50"
        >
          {loading ? "rendering…" : "sign in"}
        </button>
        <Link to="/" className="block text-center mt-5 font-mono text-xs text-mute hover:text-txt transition-colors">← back to site</Link>
      </form>
    </div>
  );
}
